import validate from 'validate.js'

const constraints = {
  limit: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
